import { BaseDto } from "src/dtos/common/baseDto";

/** hrm_work_shift(근무조)의 API 필드와 그리드의 신규·수정 상태를 표현한다. */
export interface HrmWorkShiftDto extends BaseDto {
    shiftCd: string; // 근무조코드(PK). 근무조 배정(HRM2120)·일일근태(HRM2010)가 이 값을 참조한다.
    shiftNm: string; // 근무조명
    startTime: string; // 정시 출근(HH:MM). 지각 판정 기준
    endTime: string; // 정시 퇴근(HH:MM). 출근보다 작으면 자정을 넘기는 야간조이며, 이후 근무는 연장으로 본다.
    useYn: string; // 사용여부(Y/N). 근무조는 삭제하지 않고 N으로 사용을 멈춘다.
    remark: string; // 비고
    inserted: boolean; // true이면 아직 저장하지 않은 신규 행
    isModified: boolean; // true이면 조회 후 값이 바뀐 기존 행
}

/** 신규 근무조 행의 기본값이다. 정시 출퇴근은 실행 샘플과 같이 09:00~18:00으로 시작한다. */
export const defaultHrmWorkShiftDto: HrmWorkShiftDto = {
    valueIndex: 0,
    orderIndex: 0,
    orderIndexSeq: 0,
    shiftCd: '',
    shiftNm: '',
    startTime: '09:00',
    endTime: '18:00',
    useYn: 'Y',
    remark: '',
    inserted: false,
    isModified: false,
};
